import { createReducer } from '@reduxjs/toolkit';

import { FetchStatus } from '../../enums';
import * as actions from './actions';
import { IAuthState } from './types';

export const initialState: IAuthState = {
  status: {
    login: FetchStatus.IDLE,
    forgotPassword: FetchStatus.IDLE,
    register: FetchStatus.IDLE,
    checkEmailInDatabase: FetchStatus.IDLE,
    logout: FetchStatus.IDLE,
  },
};

export const authReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.resetForgotPasswordStatus, (state) => {
      state.status.forgotPassword = FetchStatus.IDLE;
    })
    .addCase(actions.resetRegisterStatus, (state) => {
      state.status.register = FetchStatus.IDLE;
      state.registerErrorMessage = undefined;
    })
    .addCase(actions.resetLoginStatus, (state) => {
      state.status.login = FetchStatus.IDLE;
    })
    .addCase(actions.resetCheckEmailInDatabaseStatus, (state) => {
      state.status.checkEmailInDatabase = FetchStatus.IDLE;
      state.registerErrorMessage = undefined;
    })
    .addCase(actions.resetLogoutStatus, (state) => {
      state.status.logout = FetchStatus.IDLE;
    })
    .addCase(actions.login, (state) => {
      state.status.login = FetchStatus.LOADING;
      state.auth = undefined;
      state.username = undefined;
    })
    .addCase(actions.loginSucceeded, (state, action) => {
      state.status.login = FetchStatus.SUCCESS;
      state.auth = action.payload.auth;
      state.username = action.payload.credentials.username;
    })
    .addCase(actions.loginFailed, (state) => {
      state.status.login = FetchStatus.FAILURE;
    })
    .addCase(actions.forgotPassword, (state) => {
      state.status.forgotPassword = FetchStatus.LOADING;
    })
    .addCase(actions.forgotPasswordSucceeded, (state) => {
      state.status.forgotPassword = FetchStatus.SUCCESS;
    })
    .addCase(actions.forgotPasswordFailed, (state) => {
      state.status.forgotPassword = FetchStatus.FAILURE;
    })
    .addCase(actions.register, (state) => {
      state.status.register = FetchStatus.LOADING;
      state.registerErrorMessage = undefined;
    })
    .addCase(actions.registerSucceeded, (state) => {
      state.status.register = FetchStatus.SUCCESS;
    })
    .addCase(actions.registerFailed, (state, action) => {
      state.status.register = FetchStatus.FAILURE;
      state.registerErrorMessage = action.payload.error;
    })
    .addCase(actions.checkEmailInDatabase, (state) => {
      state.status.checkEmailInDatabase = FetchStatus.LOADING;
      state.registerErrorMessage = undefined;
    })
    .addCase(actions.checkEmailInDatabaseSucceeded, (state) => {
      state.status.checkEmailInDatabase = FetchStatus.SUCCESS;
    })
    .addCase(actions.checkEmailInDatabaseFailed, (state, action) => {
      state.status.checkEmailInDatabase = FetchStatus.FAILURE;
      state.registerErrorMessage = action.payload.error;
    })
    .addCase(actions.logout, (state) => {
      state.status.logout = FetchStatus.LOADING;
    })
    .addCase(actions.logoutSucceeded, (state) => {
      state.status.logout = FetchStatus.SUCCESS;
      state.auth = undefined;
      state.username = undefined;
    })
    .addCase(actions.logoutFailed, (state) => {
      state.status.logout = FetchStatus.FAILURE;
    });
});
